



















import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    pageData
} from "@/store/pageData";
import ColorImgText from '../components/Home/ColorImgText.vue';
import TitleCounterblock from '../components/Home/TitleCounterblock.vue';
import TabImgContent from '../components/Home/TabImgContent.vue';
import CeoBlock from '../components/Home/CeoBlock.vue';
import AwardBlock from '../components/Home/AwardBlock.vue';
import HomeHeader from '../components/HomeHeader.vue';
import VideoBanner from '../components/VideoBanner.vue';
@Component({
    name: "HomePage",
    components: {
        slider: HomeHeader,
        youtube_video_block: VideoBanner,
        home_title_text_image_cta: ColorImgText,
        mission_vision_block: TitleCounterblock,
        home_tab_block: TabImgContent,
        ceo_message: CeoBlock,
        title_subtitle_text_image_cta: AwardBlock,

    }
})
export default class HomePage extends Vue {
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    public HOST: string = HOST;

}
